// extracted by mini-css-extract-plugin
export default {"wrapper":"accept-terms-module--wrapper--69320"};